import styled from 'styled-components'
export const StyledPayWithCheck = styled.div`
    .field {
        margin-bottom: 20px;
    }
`
